export const environment = {
  appName: 'Perse ConsentWallet',
  appUrl: 'https://dev.opendata.energy',
  appVersion: require('../../package.json').version,

  whiteLabel: null,
  logo: 'https://s3.eu-west-1.amazonaws.com/assets.perse.io/perse_logos/perse_green_with_text.svg', // TODO:: Change the URL
  docsBaseUrl: 'https://assets.perse.io/consent-wallet',


  // AWS Cognito Configuration
  cognito: {
    userPoolId: 'eu-west-1_kQI7boF76',
    userPoolClientId: '883c61qt6lrhvu1avsun7o9bu',
    region: 'eu-west-1',
  },
  
  header: 'ConsentWallet: access your',
  primaryHeader: '',
  highlightHeader: 'utility data',
  description: 'Provide permissions for us to retrieve your data,See your data instantly,Download your data,Put your data to use to save energy and money',

  baseUrl: 'https://api.preprod.perse.io',
  baseUrlCarbon: 'https://api.dev.lab.thelabrador.co.uk',
  baseUrlOrg: 'https://api.thelabrador.co.uk',
  baseUrlMasterSearch: 'https://api.thelabrador.co.uk',
  baseUrlSoftwareProviders: 'https://api.preprod.perse.io',
  // Stakeholder roles (public, read-only) live in the admin API, which is only deployed to prod.
  baseUrlStakeholderRoles: 'https://api.perse.io/admin',
  baseUrlMeterHistory: 'http://domestic-prod-alb-terra-1678302567.eu-west-1.elb.amazonaws.com:7000',
  openDataApiUrl: 'https://api.preprod.perse.io',

  // apiKey: 'U2FsdGVkX192qixrCGGatPyyOZ5JgJlfXxYWqyouY86AVVRAkktVgOiAwm93hdkGaX/DbFqO5qeqcE9+ael15g==',
  apiKey: '620d7b80-8bd7-4c6f-a2f8-86cac8612c58',
  perseClientKey: 'PERSE-TEST-CLIENT-APIKEY-0fcac2975984',
  eApiKey: 'U2FsdGVkX1+s5ejdvT1hgiPsye4vgpGwW16KWdK2pH4=',
  apiKeyOrg: 'U2FsdGVkX192qixrCGGatPyyOZ5JgJlfXxYWqyouY86AVVRAkktVgOiAwm93hdkGaX/DbFqO5qeqcE9+ael15g==',
  ignoreAuthRequests: ['core', 'carbon', 'org', 'meterhistory', 'amazonaws', 'smart', 'assets.perse.io', 'stakeholder-roles'],
  
  // Authentication URLs
  magicLinkRedirectUrl: 'https://dev.opendata.energy/auth?link=',
  magicLinkSdk: 'https://dev.opendata.energy/sdk-auth?link=',

  termsVersion: '25-Jan-2025',
  privacyPolicyVersion: '29-May-2025',

  termsUrl: 'https://perse.io/terms',
  privacyPolicyUrl: 'https://perse.io/privacy-policy',


  // Stripe Configuration
  stripePublishableKey: 'pk_test_51JxW6DGZhSWPrNLwZ1ZQqsTCZP98een3OlWBhbQpMFwPOgtxvxHFmjcr8SyVG4hnJeJynY0f0YEf2zL7AUpY4M4p00XsKtEJqf', // Replace with your actual Stripe publishable key

  trackerId: 'CONSENT_WALLET'
};
